module.exports = __webpack_public_path__ + "static/media/Lato-Bold.5b1b8b85.ttf";